import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators"
import { setLanguage } from "@/utils/storage"
import { getLocale } from "@/lang"
import DeviceDetector, { DeviceDetectorResult, DeviceDetectorOptions } from "device-detector-js"
import store from "@/store"

export interface IAppState
{
	language: string,
	headerMenu:
	{
		showing: boolean
	},
	modalIsShowing: boolean,
	scrollPosition: number
}

@Module({ dynamic: true, store, name: "app" })
class App extends VuexModule implements IAppState
{
	public language = getLocale()
	public modalIsShowing = false
	public headerMenu =
		{
			showing: false
		}

	public scrollPosition = 0
	public device: DeviceDetectorResult = {
		client: null,
		device: null,
		os: null,
		bot: null
	}

	constructor()
	{
		super(VuexModule)
		const deviceDetector = new DeviceDetector()
		const device = deviceDetector.parse(navigator.userAgent)
		this.device = device

		// device.device.model is empty on real devices, but not on emulators.
		if (device.os && device.os.name === "iOS" && device.device && device.device.model === "")
		{
			(document.getElementsByTagName("body")[0] as HTMLBodyElement).classList.add("isios")
		}
	}

	@Mutation
	private SET_LANGUAGE(language: string)
	{
		this.language = language
		setLanguage(this.language)
	}

	@Mutation
	private TOGGLE_HEADERMENU()
	{
		this.headerMenu.showing = !this.headerMenu.showing

		if (this.headerMenu.showing)
		{
			(document.getElementsByTagName("body")[0] as HTMLBodyElement).classList.add("menutoggled")
		}
		else
		{
			(document.getElementsByTagName("body")[0] as HTMLBodyElement).classList.remove("menutoggled")
		}
	}

	@Mutation
	private HIDE_HEADERMENU()
	{
		this.headerMenu.showing = false

		if (!this.headerMenu.showing)
		{
			(document.getElementsByTagName("body")[0] as HTMLBodyElement).classList.remove("menutoggled")
		}
	}

	@Mutation
	private SET_MODAL_IS_SHOWING(isShowing: boolean)
	{
		this.modalIsShowing = isShowing

		if (isShowing)
		{
			(document.getElementsByTagName("body")[0] as HTMLBodyElement).classList.add("modaloverflow")
		}
		else
		{
			(document.getElementsByTagName("body")[0] as HTMLBodyElement).classList.remove("modaloverflow")
		}
	}

	@Mutation
	private SET_SCROLLPOSITION(scrollPosition: number)
	{
		this.scrollPosition = scrollPosition
	}

	@Action
	public SetLanguage(language: string)
	{
		this.SET_LANGUAGE(language)
	}

	@Action
	public ToggleHeaderMenu()
	{
		this.TOGGLE_HEADERMENU()
	}

	@Action
	public HideHeaderMenu()
	{
		this.HIDE_HEADERMENU()
	}

	@Action
	public SetModalIsShowing(isShowing: boolean)
	{
		this.SET_MODAL_IS_SHOWING(isShowing)
	}

	@Action
	public SetScrollPosition(scrollPosition: number)
	{
		this.SET_SCROLLPOSITION(scrollPosition)
	}
}

export const AppModule = getModule(App)
